import React from 'react';
import { PropTypes } from 'prop-types';
import { isNil, groupBy } from 'lodash';
import CreditReason from './CreditReason';

export const CreditReasons = ({ credit, ...props }) => {
  if (isNil(credit) || isNil(credit.reasons)) {
    return null;
  }

  const reasonsGroup = groupBy(credit?.reasons, 'type');
  const reasonsEntries = Object.entries(reasonsGroup);

  return reasonsEntries.map(reasonEntry => (
    <CreditReason key={reasonEntry[0]} reasonType={reasonEntry[0]} reasons={reasonEntry[1]} {...props} />
  ));
};

CreditReasons.propTypes = {
  credit: PropTypes.shape({
    reasons: CreditReason.propTypes.reasons,
  }),
  creditDecisionDetails: CreditReason.propTypes.creditDecisionDetails,
  layout: CreditReason.propTypes.layout,
};
